import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from './firebaseClient';
import { App as CapacitorApp } from '@capacitor/app';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import DisplayPage from './pages/DisplayPage';

export default function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [showExitConfirm, setShowExitConfirm] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        setShowExitConfirm(true);
      }
    });
    return () => {
      CapacitorApp.removeAllListeners();
    };
  }, []);

  const handleExit = () => CapacitorApp.exitApp();
  const handleCancel = () => setShowExitConfirm(false);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1e3a5f, #3b82f6)',
      }}>
        <img
          src="/icon_512.jpg"
          alt="logo"
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '24px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
            marginBottom: '24px',
          }}
        />
        <p style={{
          fontSize: '1.3rem',
          fontWeight: '700',
          color: '#fff',
          marginBottom: '8px',
          fontFamily: 'sans-serif',
        }}>
          소상공인 계좌QR
        </p>
        <p style={{
          fontSize: '0.9rem',
          color: 'rgba(255,255,255,0.7)',
          fontFamily: 'sans-serif',
        }}>
          잠시만 기다려주세요...
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      {showExitConfirm && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '28px 24px',
            width: '80%',
            maxWidth: '320px',
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
          }}>
            <p style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '8px' }}>앱 종료</p>
            <p style={{ fontSize: '0.95rem', color: '#666', marginBottom: '24px' }}>앱을 종료하시겠습니까?</p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={handleCancel}
                style={{
                  flex: 1, padding: '12px', borderRadius: '8px',
                  border: '1px solid #ddd', backgroundColor: '#f5f5f5',
                  fontSize: '0.95rem', cursor: 'pointer'
                }}
              >
                취소
              </button>
              <button
                onClick={handleExit}
                style={{
                  flex: 1, padding: '12px', borderRadius: '8px',
                  border: 'none', backgroundColor: '#3b82f6',
                  color: '#fff', fontSize: '0.95rem', cursor: 'pointer'
                }}
              >
                종료
              </button>
            </div>
          </div>
        </div>
      )}
      <Routes>
        <Route path="/display" element={<DisplayPage />} />
        <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
        <Route path="/" element={user ? <HomePage user={user} /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
